import React from 'react';

function CDMLogo({ size = 40 }) {
	const W = size * 1.15,
		H = size * 0.9;
	const r = size * 0.42,
		cy = H * 0.52;
	const midX = W / 2,
		offset = size * 0.13;
	const cx1 = midX - offset,
		cx2 = midX + offset;
	return (
		<svg
			width={W}
			height={H}
			viewBox={`0 0 ${W} ${H}`}
			fill='none'
			style={{ overflow: 'visible', flexShrink: 0 }}
		>
			<defs>
				<clipPath id='cdm-c2'>
					<circle cx={cx2} cy={cy} r={r} />
				</clipPath>
			</defs>
			<circle cx={cx1} cy={cy} r={r} fill='#6DBF67' opacity='0.85' />
			<circle cx={cx2} cy={cy} r={r} fill='#1A7A6E' opacity='0.85' />
			<circle
				cx={cx1}
				cy={cy}
				r={r}
				fill='#2BA898'
				clipPath='url(#cdm-c2)'
				opacity='0.9'
			/>
			<text
				x={midX}
				y={cy + size * 0.085}
				textAnchor='middle'
				fontFamily='DM Sans, sans-serif'
				fontWeight='700'
				fontSize={size * 0.22}
				fill='white'
				letterSpacing='1'
			>
				CDM
			</text>
		</svg>
	);
}

export default CDMLogo;
